<template>
  <el-dropdown
    class="FileActions"
    trigger="click"
    placement="left">
      <div class="FileActions__image-wrapper">
        <SvgImage
        imageName="FileMore"
        class="FileActions__image"/>
      </div>
      <el-dropdown-menu
      slot="dropdown"
      class="FileActions__dropdown">
        <el-dropdown-item
        v-if="canDownload">
          <div
          class="FileActions__dropdown-element"
          @click="shareFileAction(file, true)">
            <SvgImage
            imageName="FileSendKingsChat"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Send to KingsChat Friend</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item
        v-if="canDownload">
          <div
          class="FileActions__dropdown-element"
          @click="shareFileAction(file, false)">
            <SvgImage
            imageName="FileShare"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Share download link</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item
        v-if="canDownload">
          <div
          class="FileActions__dropdown-element"
          @click="pushFileDownload(file)">
            <SvgImage
            imageName="FileDownload"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Download</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div
          class="FileActions__dropdown-element"
          @click="setModalFile({ modal: 'rename', file })">
            <SvgImage
            imageName="FileRename"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Rename</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div
          class="FileActions__dropdown-element"
          @click="setModalFile({ modal: 'move', file })">
            <SvgImage
            imageName="FileMove"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Move</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div
          class="FileActions__dropdown-element FileActions__dropdown-element--red"
          @click="fileDelete(file)">
            <SvgImage
            imageName="FileDelete"
            class="FileActions__dropdown-icon"/>
            <span
            class="FileActions__dropdown-name">Delete</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
import { mapActions } from 'vuex'

import FileDeleteMixin from '@/components/mixins/FileDelete.mixin'
import FileShareMixin from '@/components/mixins/FileShare.mixin'

export default {
  name: 'FileActions',

  mixins: [
    FileDeleteMixin,
    FileShareMixin
  ],

  props: {
    file: {
      type: Object,
      required: true,
      validator (file) {
        return file.id && file.name && !Number.isNaN(file.type)
      }
    }
  },

  computed: {
    canDownload () {
      const downloadable = [0, 1, 2, 3, 4, 7]
      return downloadable.includes(this.file.type)
    }
  },

  methods: {
    ...mapActions('modal', [
      'setModalFile'
    ]),
    ...mapActions('filesTransfer', [
      'pushFileDownload'
    ])
  }
}
</script>

<style lang="scss">
.FileActions {
  height: 34px;
  width: 34px;

  &__image {
    width: 4px;
    height: 16px;
    min-width: 4px;
  }

  &__image-wrapper {
    justify-content: center;
    display: flex;
    height: 100%;
    padding: 5px 15px;
    cursor: pointer;
  }

  &__dropdown-element {
    align-items: center;
    display: flex;

    &--red {
      color: $brand-danger;
    }
  }

  &__dropdown-icon {
    width: 24px;
    height: 24px;
  }

  &__dropdown-name {
    width: 195px;
    padding: 15px;
    line-height: 14px;
  }
}
</style>
